import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export function InternosAdmin({ isStaff, isAdmin }) {
    return (
        <Card>
            <CardHeader><CardTitle>Usuários Internos</CardTitle></CardHeader>
            <CardContent>
                <div className="p-4 text-center text-stone-500">
                    Módulo em manutenção.
                </div>
                <div className="text-xs text-center text-stone-400">
                    Role: {isStaff ? 'Staff' : 'Admin'}
                </div>
            </CardContent>
        </Card>
    );
}
